<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li class="flex items-center"> 
              <feather-icon icon="ArrowLeftIcon" class="back-icon" @click="$router.go(-1);" svgClasses="text-dark" />
              <h3>{{ $t("leads.label.quote_details") }}</h3>
          </li>
        </ul>
      </div>
      <vx-card
        ><div class="vx-row" id="pdfContent">
          <div class="vx-col w-full pt-2">
            <div class="flex justify-between">
              <div class="info-box">
                <p class="text">
                  {{ $t("leads.label.quotation_date") }}-
                  {{ quoteData.quoteDate }}
                </p>
              </div>
              <div class="info-box">
                <p class="text">
                  {{ $t("leads.label.quotation") }} #:
                  {{ quoteData.quoteNumber }}
                </p>
              </div>
            </div>
          </div>
          <div class="vx-col w-full pt-2 mx-8 mt-4">
            <p class="text">
              Dear {{ Services.firstName }}, <br />we are delighted to share a
              quotation of your request for our service. Please find bellow
              Quotation of the Tarrif. Please send your approval for activating
              the plan.
            </p>
          </div>
          <div class="vx-col w-full pt-2 mx-8 mt-4">
            <p class="text">
              {{ $t("leads.label.service") }}:
              <span class="color-text">{{ seviceType }}</span>
            </p>
          </div>
          <div class="vx-col w-full pt-2 mx-8 mt-4">
            <div class="flex justify-between">
              <p class="text">
                {{ $t("leads.label.plan_name") }}:
                <span class="color-text">{{ quoteData.planDescription }}</span>
              </p>
              <!-- <pre>{{ quoteData }}</pre> -->
              <p class="text">
                {{ $t("leads.label.price") }}:
                <span class="color-text">{{ quoteData.oneTimeCharge }} </span>
              </p>
            </div>
          </div>
          <div class="vx-col w-1/5 pt-2 mt-4"></div>
          <div class="vx-col w-3/5 pt-2 mt-4 ">
            <p class="text-xl font-semibold">{{ $t("leads.label.product") }}</p>
          </div>
          <div class="vx-col w-full mx-8">
            <div
              class="vx-row flex items-center justify-items-center"
              v-for="(product, ind) in plan.selectedProducts"
              :key="ind"
            >
              <div class="vx-col w-1/6 pb-2">
                <p class="text">{{ product.productCode }}</p>
              </div>
              <div class="vx-col w-5/6 pt-2 mt-4">
                <vs-table
                  stripe
                  :data="planPricingInfo[product.id]"
                  class="details-table"
                >
                  <template slot="thead">
                    <vs-th>{{ $t("Charge Type") }}</vs-th>
                    <vs-th>{{ $t("Rate/UOM") }}</vs-th>
                  </template>
                  <template>
                    <vs-tr
                      v-for="(price, ind) in planPricingInfo[product.id]"
                      :key="ind"
                    >
                      <vs-td class="black">{{ price.chargeType }}</vs-td>
                      <vs-td class="black"
                        >{{ price.rate }}/{{ price.UOM }}</vs-td
                      >
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="w-full text-center mb-4">
        <vs-button
          class="mr-3 mb-2 footerButton-next"
          @click="downloadInvoicePdf"
          >{{ $t("leads.label.download") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      quoteData: {},
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    ...mapState({
      Services: (state) => state.leads.leadInfo,
      quoteList: (state) => state.leads.quoteList,
      planPricingInfo: (state) => state.leads.planPricingInfo,
      plan: (state) => state.planPrice.planWithTempate,
    }),
    seviceType() {
      if (this.quoteList && this.quoteList[0])
        return this.quoteList[0].serviceCode;
      else return "";
    },
  },
  methods: {
    downloadInvoicePdf() {
      const pdfDoc = document.querySelector("#pdfContent");
      html2canvas(pdfDoc, {
        allowTaint: true,
        useCORS: true,
        scale: 1,
        width: 1220,
        height: 1100,
      }).then((canvas) => {
        var imgData = canvas.toDataURL("image/png");
        var doc = new jsPDF("p");
        doc.addImage(imgData, "PNG", 10, 10, 190, 190);
        doc.save("output.pdf");
      });
    },
  },
  async mounted() {
    if (!Object.keys(this.Services).length) {
      await this.$store.dispatch("leads/fetchLeadInfo", this.$route.query.lead);
    }
    if (!Object.keys(this.quoteList).length) {
      await this.$store.dispatch(
        "leads/fetchAllQuotesInfo",
        this.$route.query.lead
      );
    }
    this.quoteData = this.quoteList.find(
      (el) => el.quoteId == this.$route.params.id
    );
    await this.$store.dispatch("planPrice/getPlanById", this.quoteData.planId);
    if (
      Array.isArray(this.plan.selectedProducts) &&
      this.plan.selectedProducts.length
    ) {
      this.plan.selectedProducts.forEach(async (el) => {
        await this.$store.dispatch("leads/fetchPlanPricingDetail", {
          productId: el.id,
          planId: this.quoteData.planId,
        });
      });
    }
  },
};
</script>

<style scoped>
.info-box {
  padding: 5px 8px;
  border: 1px solid rgba(121, 97, 249, 1);
  border-radius: 5px;
  margin: 0px 10px;
}
.text {
  color: #000;
  font-weight: 500;
  line-height: 25px;
}
.details-table ::v-deep .vs-con-tbody.vs-table--tbody {
  border: 1px solid rgba(121, 97, 249, 1);
}
.color-text {
  color: rgba(121, 97, 249, 1);
  font-weight: 500;
  line-height: 25px;
}
.back-icon{
  cursor: pointer;
}
</style>
